"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = void 0;

require("@babel/polyfill");

require("./polyfills/requestIdleCallback");

require("fastestsmallesttextencoderdecoder");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _axios = _interopRequireDefault(require("axios"));

var _react2 = require("@lingui/react");

var _core = require("@lingui/core");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reduxSaga = _interopRequireDefault(require("redux-saga"));

var _reduxPersist = require("redux-persist");

var _react3 = require("redux-persist/integration/react");

var _messages = require("./locales/en/messages");

var _messages2 = require("./locales/fr/messages");

var _clientMiddleware = _interopRequireDefault(require("./redux/middleware/clientMiddleware"));

var _i18n = require("./i18n");

var _ApiClient = _interopRequireDefault(require("./api/ApiClient"));

var _sagas = require("./redux/sagas");

var _root = _interopRequireDefault(require("./root"));

var _persistConfig = require("./persistConfig");

var _plurals = require("make-plural/plurals");

/* eslint-disable no-undef */

/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
const client = new _ApiClient.default();
const sagaMiddleware = (0, _reduxSaga.default)();

_core.i18n.load({
  en: _messages.messages,
  fr: _messages2.messages
});

_core.i18n.loadLocaleData({
  en: {
    plurals: _plurals.en
  },
  fr: {
    plurals: _plurals.fr
  }
});

_core.i18n.activate(_i18n.defaultLocale);

const middleware = [(0, _clientMiddleware.default)(client), sagaMiddleware, (0, _clientMiddleware.default)(_persistConfig.persistedReducer)]; // Set default baseUrl for axios

_axios.default.defaults.baseURL = '/api';
let store;
exports.store = store;

if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
  /* eslint-enable */

  exports.store = store = (0, _redux.createStore)(_persistConfig.persistedReducer, composeEnhancers((0, _redux.applyMiddleware)(...middleware)));
} else {
  exports.store = store = (0, _redux.createStore)(_persistConfig.persistedReducer, (0, _redux.compose)((0, _redux.applyMiddleware)(...middleware)));
}

sagaMiddleware.run(_sagas.rootSaga);
const content = document.getElementById('content');

if (process.env.NODE_ENV !== 'production') {
  window.React = _react.default; // enable debugger
}

const persistor = (0, _reduxPersist.persistStore)(store);

_reactDom.default.hydrate( /*#__PURE__*/_react.default.createElement(_react2.I18nProvider, {
  i18n: _core.i18n
}, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
  store: store,
  key: "provider"
}, /*#__PURE__*/_react.default.createElement(_react3.PersistGate, {
  loading: null,
  persistor: persistor
}, /*#__PURE__*/_react.default.createElement(_root.default, null)))), content);